// Checks if a color string is a valid CSS color
export function isValidCssColor(color) {
  const s = new Option().style
  s.color = color
  return s.color !== ''
}

// Converts a CSS color to a computed HEX value (e.g., "red" → "#ff0000")
export function getComputedStyleColor(color) {
  const div = document.createElement('div')
  div.style.color = color
  document.body.appendChild(div)
  const computedColor = getComputedStyle(div).color
  document.body.removeChild(div)

  const rgb = computedColor.match(/\d+/g)?.map(Number)
  if (!rgb || rgb.length < 3) return '#000000'

  return (
    '#' +
    rgb
      .slice(0, 3)
      .map((c) => c.toString(16).padStart(2, '0'))
      .join('')
  )
}

// Converts a HEX color to an RGB object
export function hexToRgb(hex) {
  hex = hex.replace(/^#/, '')
  if (hex.length === 3) {
    hex = hex.split('').map((c) => c + c).join('')
  }

  const bigint = parseInt(hex, 16)
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  }
}

// Calculates luminance (brightness) of an RGB color
export function luminance({ r, g, b }) {
  const [R, G, B] = [r, g, b].map((c) => {
    c /= 255
    return c <= 0.03928
      ? c / 12.92
      : Math.pow((c + 0.055) / 1.055, 2.4)
  })
  return 0.2126 * R + 0.7152 * G + 0.0722 * B
}

export function getButtonFontColor(colorVariableName, colorToCheck, darkFontColor = '#000000', lightFontColor='#FFFFFF') {
   if (luminance(hexToRgb(colorToCheck)) > 0.5) {
      document.documentElement.style.setProperty(colorVariableName, darkFontColor);
      return darkFontColor;
    } else{
      document.documentElement.style.setProperty(colorVariableName, lightFontColor);
      return lightFontColor;
    }
}

// Calculates Euclidean distance between two RGB colors
export function colorDistance(rgb1, rgb2) {
  return Math.sqrt(
    Math.pow(rgb1.r - rgb2.r, 2) +
    Math.pow(rgb1.g - rgb2.g, 2) +
    Math.pow(rgb1.b - rgb2.b, 2)
  )
}

// Validates primary and secondary colors, applying fallback rules
export function validateColors(primary, secondary) {
  const defaultPrimary = '#000000'
  const defaultSecondary = '#cccccc'
  const whiteRGB = { r: 255, g: 255, b: 255 }

  let messages = {}

  // Step 1: check if primary is too close to white → reset to default
  let primaryColor = getComputedStyleColor(primary)
  let primaryRGB = hexToRgb(primaryColor)
  const primaryToWhite = luminance(primaryRGB)  
  if (primaryToWhite > 0.4) {
    primaryColor = defaultPrimary
    primaryRGB = hexToRgb(primaryColor)
    messages.primaryColorTooCloseToWhite =
      'Primary color is too close to white. Resetting to default.'
  }

  // Step 2: check if secondary is too bright → use primary color
  let secondaryColor = getComputedStyleColor(secondary)
  let secondaryRGB = hexToRgb(secondaryColor)
  const secondaryLum = luminance(secondaryRGB)

  if (secondaryLum > 0.9) {
    secondaryColor = primaryColor
    secondaryRGB = primaryRGB
    messages.secondaryColorTooBright =
      'Secondary color is too bright, primary color will be used.'
  }

  // Step 3: check if secondary is too close to primary → use default secondary
  const dist = colorDistance(secondaryRGB, primaryRGB)
  if (dist < 50) {
    secondaryColor = defaultSecondary
    messages.secondaryColorCloseToPrimary =
      'Secondary color is too close to primary color, default secondary color will be used.'
  }

  return {
    ...messages,
  }
}
